var map = {
	"./de/group-logo.png": "IZxY",
	"./en/group-logo.png": "nuSy",
	"./es/group-logo.png": "K3MS",
	"./fr/group-logo.png": "Mt0o",
	"./ja/group-logo.png": "eP61",
	"./ko/group-logo.png": "vWjD",
	"./pt/group-logo.png": "VPR6",
	"./ru/group-logo.png": "vTEi",
	"./tc/group-logo.png": "wLzP",
	"./th/group-logo.png": "geik"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ro5K";